/* global QuickTooltip */

import ReactDOM from "react-dom";
import App from "okpay/components/App";
import Store from "okpay/stores/Store";
import getInitialState from "okpay/stores/getInitialState";

window.OkPay = {
	initted: false,

	init(_data) {
		const data = { ..._data };

		this.initted = true;
		data.isActive = true;
		this.import(data);

		QuickTooltip.init();

		ReactDOM.render(
			<App />,
			document.getElementById("okpay-wrapper"),
		);
	},

	unmount() {
		const initialState = getInitialState();
		Store.set(initialState);
	},

	import(data = {}) {
		Store.set(data);
	},

	hide() {
		if (Store.get("isActive")) {
			Store.set({ isActive: false });
			return true;
		}

		return false;
	},

	show() {
		if (!Store.get("isActive")) {
			Store.set({ isActive: true });
			return true;
		}

		return false;
	},
};



// WEBPACK FOOTER //
// ./src/reflux/okpay/index.js